function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}var AnalyticsProviderInterface = /*#__PURE__*/function () {
  function AnalyticsProviderInterface() {var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};_classCallCheck(this, AnalyticsProviderInterface);
    this.options = options;
  }
  /**
     * Called by ViewerAnalytics to register this provider
     * Implementer should throw an error on failure
     */_createClass(AnalyticsProviderInterface, [{ key: "init", value: function init()
    {}

    /**
        * Called after init. This could be used to register super properties
        */ }, { key: "register", value: function register()
    {} }, { key: "optIn", value: function optIn(

    options) {} }, { key: "optOut", value: function optOut(
    options) {} }, { key: "hasOptedOut", value: function hasOptedOut()
    {} }, { key: "getDistinctId", value: function getDistinctId()
    {} }, { key: "track", value: function track(
    event, properties) {} }, { key: "identify", value: function identify(
    distinctId) {} }, { key: "name", get: function get() {} }]);return AnalyticsProviderInterface;}();export { AnalyticsProviderInterface as default };


var namespace = AutodeskNamespace('Autodesk.Viewing.Private');
namespace.AnalyticsProviderInterface = AnalyticsProviderInterface;